import React, {Suspense, lazy} from "react";
import ComponentLoader from "./ComponentLoader"

const Loader = () => <div style={{display: "flex", justifyContent: "center", padding: 40}}><ComponentLoader/></div>;

export default ({children}) => <Suspense fallback={<Loader/>}>
    {children}
</Suspense>